export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.multiple,
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: !that.multiple,
  },
  {
    title: that.$l('table_label_amzSkuNo') || '亚马逊SKU编号',
    field: 'amzSkuNo',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_asinCode') || 'ASIN',
    field: 'asinCode',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fnskuCode') || 'FNSKU',
    field: 'fnskuCode',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_amzGoodsSkuNo') || '产品SKU编号',
    field: 'amzGoodsSkuNo',
    width: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_ncNo') || 'NC物料编码',
    field: 'ncNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_brand') || 'SKU品牌',
    field: 'brandName',
    minWidth: 180,
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_sellType') || '售卖方式',
    field: 'sellType',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'sellType' },
  },
  {
    title: that.$l('table_label_storeSkuStatus') || '售卖状态',
    field: 'storeSkuStatus',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_salesGoodsName') || '售卖名称',
    field: 'salesGoodsName',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_salesTitle') || '售卖标题',
    field: 'salesTitle',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'salesTitle' },
  },
  {
    title: that.$l('table_label_salesPrice') || '售卖价格',
    field: 'v_salesPrice',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fbaDeliveryFee') || 'FBA配送费',
    field: 'fbaDeliveryFee',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_operateName') || '运营人员',
    field: 'operateName',
    width: 160,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_firstOnShelvesDate') || '首次上架日期',
    field: 'firstOnShelvesDate',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
